// context/UsersContext.tsx
import { createContext, useContext, useState, ReactNode } from "react";
import { customersApi } from 'src/api/endpoints/customers';// adjust path as needed

type User = {
  user_id: string;
  client_id: string;
  pid: string | null;
  tid: string | null;
  bank_id: string | null;
  user_type: string;
  email: string;
  mobile: string;
  created_at: string;
  updated_at: string;
};

type UsersContextType = {
  users: User[];
  fetchUsers: (clientId: string) => Promise<void>;
  loading: boolean;
  error: string | null;
};

const UsersContext = createContext<UsersContextType | undefined>(undefined);

export const UsersProvider = ({ children }: { children: ReactNode }) => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  console.log('UsersProvider', users, loading, error);
  const fetchUsers = async (clientId: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await customersApi.getUsersByClientId(clientId);
      
      setUsers(res?.data?.users); // based on your response format
    } catch (err: any) {
      setError(err.message || "Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  return (
    <UsersContext.Provider value={{ users, fetchUsers, loading, error }}>
      {children}
    </UsersContext.Provider>
  );
};

export const useUsers = () => {
  const context = useContext(UsersContext);
  if (!context) throw new Error("useUsers must be used within a UsersProvider");
  return context;
};
